export default "__VITE_ASSET__485a1c30__"